export default __webpack_public_path__ + "static/media/Icon-Invoice-White.e8b4a0ca.svg";